export default {
  redeemCode: {
    title: 'Redeem Code',
    description: 'Enter your redeem code below to claim your reward.',
    enterTip: 'Enter your redeem code to claim rewards',
    label: 'Redeem Code',
    placeholder: 'Please Enter Your Code',
    submit: 'REDEEM',
    redeemBtn: 'REDEEM',
    submitting: 'REDEEMING...',
    success: 'Code redeemed successfully!',
    redeemSuccess: 'Code redeemed successfully!',
    failed: 'Failed to redeem code, please try again.',
    redeemFailed: 'Failed to redeem code, please try again.'
  }
};
